import { clsx } from "clsx";

import { ClothingCategoryData } from "../../data/clothing/clothing-category.data";
import * as styles from "./CategorySidebar.module.scss";

interface CategorySidebarProps {
  categories?: ClothingCategoryData[];
  activeId: string;
  onChange: (id: string) => void;
}

export function CategorySidebar({
  categories,
  activeId,
  onChange,
}: CategorySidebarProps) {
  return (
    <nav className={styles.categorySidebar}>
      <div className={styles.categorySidebarScroll}>
        {categories?.map((category) => {
          const isActive = category.id === activeId;
          return (
            <button
              key={category.id}
              type="button"
              className={clsx(styles.categorySidebarItem, {
                [styles.categorySidebarItemActive]: isActive,
              })}
              onClick={() => onChange(category.id)}
            >
              {category.name}
            </button>
          );
        })}
      </div>
    </nav>
  );
}
